export default "__VITE_ASSET__CNRO$sj2__"